<!-- https://www.tiptap.dev/ -->
<template>
  <div>
    <div v-if="!readOnly" >
      <div v-if="editor" class="btn-group mb-2" role="group" aria-label="Text format toolbar">

        <button @click="editor.chain().focus().toggleBold().run()"
                :class="{ 'toolbar-btn' : true, 'active': editor.isActive('bold') }"
                data-toggle="tooltip" data-placement="top" title="Bold"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'bold']"/>
        </button>
        <button @click="editor.chain().focus().toggleItalic().run()"
                :class="{ 'toolbar-btn' : true,  'active': editor.isActive('italic') }"
                data-toggle="tooltip" data-placement="top" title="Italic"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'italic']"/>
        </button>
        <button @click="editor.chain().focus().toggleItalic().run()"
                :class="{ 'toolbar-btn' : true,  'active': editor.isActive('underline') }"
                data-toggle="tooltip" data-placement="top" title="Underline"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'underline']"/>
        </button>
        <button @click="editor.chain().focus().toggleStrike().run()"
                :class="{ 'toolbar-btn' : true,  'active': editor.isActive('strike') }"
                data-toggle="tooltip" data-placement="top" title="Strike"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'strikethrough']"/>
        </button>
        <button @click="editor.chain().focus().toggleCode().run()"
                :class="{ 'toolbar-btn' : true,  'active': editor.isActive('code') }"
                data-toggle="tooltip" data-placement="top" title="Code"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'code']"/>
        </button>
        <button @click="editor.chain().focus().unsetAllMarks().run()" class="toolbar-btn"
                data-toggle="tooltip" data-placement="top" title="Remove format"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'remove-format']"/>
        </button>

      </div>

      <div v-if="editor" class="btn-group mb-2" role="group" aria-label="Text format toolbar">
        <button @click="editor.chain().focus().setHardBreak().run()" class="toolbar-btn"
                data-toggle="tooltip" data-placement="top" title="Hard line break"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'level-down']"/>
        </button>
        <button @click="editor.chain().focus().setHorizontalRule().run()" class="toolbar-btn"
                data-toggle="tooltip" data-placement="top" title="Insert horizontal rule"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'horizontal-rule']"/>
        </button>

      </div>
      <div v-if="editor" class="btn-group mb-2" role="group" aria-label="Text format toolbar">
        <!--    <button @click="editor.chain().focus().clearNodes().run()">-->
        <!--      clear nodes-->
        <!--    </button>-->


        <b-dropdown right :text="
        editor.isActive('paragraph') ? 'Paragraph ':
        editor.isActive('heading', { level: 1 }) ? 'Header 1 ':
        editor.isActive('heading', { level: 2 }) ? 'Header 2 ':
        editor.isActive('heading', { level: 3 }) ? 'Header 3 ':
        editor.isActive('heading', { level: 4 }) ? 'Header 4 ':
        editor.isActive('heading', { level: 5 }) ? 'Header 5 ':
        editor.isActive('heading', { level: 6 }) ? 'Header 6 ':
        'Text'
        " variant="outline-secondary" style=" height: 34px; " class="toolbar-combo"
                    data-toggle="tooltip" data-placement="top" title="Paragraph style"
        >
          <b-dropdown-item
              @click="editor.chain().focus().setParagraph().run()"
              :class="{'toolbar-combo-item' : true,  'active': editor.isActive('paragraph') }">
            <font-awesome-icon class="fa-sm" v-if="editor.isActive('paragraph')" :icon="[iconStyle, 'check-square']"/>
            <font-awesome-icon class="fa-sm" v-else :icon="[iconStyle, 'square']"/>
            Paragraph
          </b-dropdown-item>


          <b-dropdown-item @click="editor.chain().focus().toggleHeading({ level: index }).run()"
                           :class="{'toolbar-combo-item' : true,  'active': editor.isActive('heading', { level: index }) }"
                           v-for="index in 6" :key="index"
          >
            <font-awesome-icon class="fa-sm" v-if="editor.isActive('heading', { level: index }) " :icon="[iconStyle, 'check-square']"/>
            <font-awesome-icon class="fa-sm" v-else :icon="[iconStyle, 'square']"/>
            Header {{index}}
          </b-dropdown-item>

        </b-dropdown>


        <button @click="editor.chain().focus().toggleBulletList().run()"
                :class="{ 'toolbar-btn' : true, 'active': editor.isActive('bulletList') }"
                data-toggle="tooltip" data-placement="top" title="Bullet list"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'list']"/>
        </button>
        <button @click="editor.chain().focus().toggleOrderedList().run()"
                :class="{ 'toolbar-btn' : true, 'active': editor.isActive('orderedList') }"
                data-toggle="tooltip" data-placement="top" title="Ordered list"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'list-ol']"/>
        </button>

        <!--    <button @click="editor.chain().focus().toggleCodeBlock().run()" :class="{ 'active': editor.isActive('codeBlock') }">-->
        <!--      code block-->
        <!--    </button>-->
        <button @click="editor.chain().focus().toggleBlockquote().run()"
                :class="{ 'toolbar-btn' : true, 'active': editor.isActive('blockquote') }"
                data-toggle="tooltip" data-placement="top" title="Quote"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'quote-right']"/>
        </button>

        <button @click="editor.chain().focus().undo().run()" class="toolbar-btn"
                data-toggle="tooltip" data-placement="top" title="Undo"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'undo']"/>
        </button>
        <button @click="editor.chain().focus().redo().run()" class="toolbar-btn"
                data-toggle="tooltip" data-placement="top" title="Redo"
        >
          <font-awesome-icon class="fa-sm" :icon="[iconStyle, 'redo']"/>
        </button>

      </div>



      <div  data-test-path="editor" class="border-secondary border" :style="'overflow-y:scroll; border-radius: 4px; height: ' + height + 'px; cursor:text'" @click.stop="editor.chain().focus().run()">
        <editor-content  ref="editor" class="pl-1 pr-1 pb-1" style="height: 100%" :editor="editor"/>
      </div>
    </div>

    <div class="form-control grey-label ProseMirror" v-html="content"  :style="'height: ' + height + 'px; overflow-y:auto;'"
         v-if="readOnly"
    >
      {{content}}
    </div>

  </div>


</template>

<style lang="sass">

.ProseMirror-focused
  border: none !important
  border-image: none !important

.ProseMirror-focused [contenteditable]
  outline: 0px solid transparent

[contenteditable]:focus
  outline: 0px solid transparent

.ProseMirror
  > * + *
    margin-top: 0.75em

  ul,
  ol
    padding: 0 1rem

  h1,
  h2,
  h3,
  h4,
  h5,
  h6
    line-height: 1.1
    margin: 0

  p
    margin: 0

  code
    background-color: rgba(#616161, 0.1)
    color: #616161

  pre
    background: #0D0D0D
    color: #FFF
    font-family: 'JetBrainsMono', monospace
    padding: 0.75rem 1rem
    border-radius: 0.5rem

    code
      color: inherit
      padding: 0
      background: none
      font-size: 0.8rem

  img
    max-width: 100%
    height: auto

  blockquote
    padding-left: 1rem
    border-left: 2px solid rgba(#0D0D0D, 0.1)

  hr
    border: none
    border-top: 2px solid rgba(#0D0D0D, 0.1)
    margin: 2rem 0

.toolbar-combo  button
  padding-top: 4px !important


</style>
<script>
import {Editor, EditorContent} from '@tiptap/vue-2'
import StarterKit from '@tiptap/starter-kit'
import Underline from '@tiptap/extension-underline'
import {parseIconName} from "@/FontAwesomeSetup";

export default {
  components: {
    EditorContent
  },
  name: "FormattedInput",

  created() {
    this.formatText();
  },

  beforeDestroy() {
    this.editor.destroy()
  },

  props: {
    validatedField: null,
    autofocus: {type: Boolean, default: false},
    content: {type: String, default: ""},
    height: {type: String, default: "200"},
    readOnly: {type: Boolean, default: false}
  },

  methods: {
    focusOut() {
      this.$emit("focusout");
    },
    formatText(){
      const that = this;
      this.intContent = this.content ?? "";
      this.editor = new Editor({
        content: this.intContent,
        autofocus: this.autofocus,
        onUpdate({editor}) {
          if(that.intContent !== editor.getHTML()){
            that.intContent = editor.getHTML();
            that.$emit("modelChange", that.intContent);
          }
        },
        onBlur({editor}) {
          that.focusOut();
          // that.validatedField?.validate();
        },
        extensions: [
          StarterKit,
          Underline
        ]
      })
    }
  },

  watch: {
    content: function (val) {
      let html = this.editor.getHTML();
      if (html !== val) {
        this.editor.commands.setContent(val ?? "");
      }
    },
  },

  data() {
    return {
      editor: null,
      iconStyle: 'fal',
      intContent: '',
    }
  },

  model: {
    prop: 'content',
    event: 'modelChange'
  },
}
</script>